
import { store } from '../../store';
import Rest from '../../webapi/Rest';
import BaseActions from '../../app/_base_actions';
import AppActions from '../../app/app_actions';
import { Utils, DateFormatter, domain, i18n } from 'arm-common';


const EnumFamiglieProdottoActions = Object.freeze({

    FAMIGLIE_LIST: 'FAMIGLIE_LIST',
    FAMIGLIE_LIST: 'FAMIGLIE_LIST',
    FAMIGLIA_DETAILS: 'FAMIGLIA_DETAILS',
    FAMIGLIA_HANDLE_CHANGE: 'FAMIGLIA_HANDLE_CHANGE',
    FAMIGLIE_UPDATE: 'FAMIGLIE_UPDATE'


});

module.exports.EnumFamiglieProdottoActions = EnumFamiglieProdottoActions;


class FamiglieProdottoActions extends BaseActions {
    constructor() {
        super();
        this.moduleName = "[FamiglieProdottoActions] ";
    }
    get Actions() {

        return EnumFamiglieProdottoActions;
    }





    getListFamiglie() {
        return function (dispatch) {
            return Rest.post('admin/famigliaProdotto/listaFamiglie', null, dispatch).then(
                resolve => {
                    dispatch({ type: EnumFamiglieProdottoActions.FAMIGLIE_LIST, dati: resolve });
                    return resolve
                }, reject => {
                    return reject;
                });
        }
    }
    getFamigliaDetails(id) {
        return function (dispatch) {
            return Rest.postForm('admin/famigliaProdotto/getFamigliaProdottoById', { id: id }, dispatch).then(
                resolve => {
                    dispatch({ type: EnumFamiglieProdottoActions.FAMIGLIA_DETAILS, dati: resolve });
                    return resolve
                }, reject => {
                    return reject;
                });
        }

    }

    clearAll() {
        return function (dispatch) {
            dispatch({ type: EnumFamiglieProdottoActions.FAMIGLIE_LIST });
        }
    }

    handleChange(id, value) {
        return function (dispatch) {
            let object = {};
            object[id] = value;
            dispatch({
                type: EnumFamiglieProdottoActions.FAMIGLIA_HANDLE_CHANGE,
                dato: object
            });
        }
    }

    salvaFamiglia(ambito) {
        return function (dispatch, getState) {
            let famigliaToSave = new Object();
            famigliaToSave = getState().famiglieProdotto.famigliaProdotto;
            if (ambito !== undefined) {
                famigliaToSave.codAmbito = ambito;
            }
            return Rest.post("admin/famigliaProdotto/salvaFamigliaProdotto", famigliaToSave, dispatch).then(
                function (resolve) {
                    dispatch({ type: EnumFamiglieProdottoActions.FAMIGLIA_DETAILS, dati: resolve });
                    if (famigliaToSave.id === null || famigliaToSave.id === undefined) {
                        dispatch(AppActions.addNotify('SUCCESS', i18n('ARM_CORE_PRODUCT.FAMIGLIE.FAMIGLIA_INSERITA_CON_SUCCESSO', 'Famiglia inserita con successo')));
                    } else {
                        dispatch(AppActions.addNotify('SUCCESS', i18n('ARM_CORE_PRODUCT.FAMIGLIE.FAMIGLIA_MODIFICATA_CON_SUCCESSO', 'Famiglia modificata con successo')));
                    }
                    return resolve;
                },
                function (reject) {
                    return reject;
                });
        }
    }

    deleteFamiglia() {
        return function (dispatch, getState) {
            let id = getState().famiglieProdotto.famigliaProdotto.id;
            let categorieProdotto = getState().famiglieProdotto.famigliaProdotto?.listCategorieProdotto;
            if (categorieProdotto != null && categorieProdotto != undefined && categorieProdotto.length > 0) {
                let messaggioErrore = "ATTENZIONE! La Famiglia-Prodotto che si sta eliminando è asscociata ad una categoria-prodotto. Occorre procedere prima all'eliminazione della categorie-prodotto. " 
                dispatch(AppActions.addNotify('DANGER', messaggioErrore));
                 return Promise.reject()
            }

            return Rest.postForm('admin/famigliaProdotto/eliminaFamigliaProdotto', { id: id }, dispatch).then(
                resolve => {
                    dispatch({ type: EnumFamiglieProdottoActions.FAMIGLIA_DETAILS, dati: resolve });
                    dispatch(AppActions.addNotify('SUCCESS', i18n('ARM_CORE_PRODUCT.FAMIGLIE.FAMIGLIA_ELIMINATA_CON_SUCCESSO', 'Famiglia eliminata con successo')));
                    return resolve
                }, reject => {
                    return reject;
                });
        }
    }

    inizializzaNuovaFamiglia() {
        return function (dispatch) {
            dispatch({ type: EnumFamiglieProdottoActions.FAMIGLIA_DETAILS, dati: {} });

            return Promise.resolve();
        }
    }

    uploadImage(formData) {
        console.log(" uploadImage ");
        return (dispatch, getState) => {
            let options = {};
            options.contentType = false;
            options.processData = false;
            options.async = false;
            return Rest.postForm('admin/famigliaProdotto/importImage', formData, dispatch, options)
                .then(resolve => {
                    let famigliaProdotto = {
                        famigliaProdotto:
                        {
                            imagine: {
                                $set: resolve.imagine
                            },

                        },
                    }

                    dispatch({
                        type: EnumFamiglieProdottoActions.FAMIGLIE_UPDATE,
                        famiglieProdotto: famigliaProdotto
                    });
                    dispatch(AppActions.addNotify('SUCCESS', 'Imagine importata con successo'));
                    return resolve;
                },
                    reject => {
                        return reject;
                    }
                );
        }
    }


};

export default FamiglieProdottoActions = new FamiglieProdottoActions;
